import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicDropdown} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicDropdown';

export {DynamicDropdown};
export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
    data: state.dynamicComponent.data,
    context: state.dynamicComponent.context,
    jwt: state.auth.token,
  };
};
export default connect(mapStateToProps)(connectDynamic(DynamicDropdown));
